import React, {Component} from 'react';
import Priority from '../templates/priority';

class priorityPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:    [],
            message: {},
        };
    }

    changeState(data) {
        this.setState(data)
    }

    render() {
        return (
            <div className="">
                <Priority {...this}/>
            </div>
        );
    }
}

export default priorityPage;
